import React, { FC } from 'react';
import { Table } from '../../common';
import { ProjectsReportRecord } from '../../types';
import { usePhasesAndTasksColumns } from './columns';

export const PhasesAndTasksViewTable: FC<{
  projectsReportRecords: ProjectsReportRecord[];
}> = ({ projectsReportRecords }) => {
  const columns = usePhasesAndTasksColumns({
    noOfRows: projectsReportRecords.length,
  });

  return <Table columns={columns} dataSource={projectsReportRecords} />;
};
